import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import {
	ContactUpdateAddressDiffEntryResource,
	ContactUpdateAddressDiffRowResource,
} from "../../../../shared/types/contactUpdateInquiry";
import {
	ContactUpdateBaseRelationDiffRow,
	ContactUpdateInquiryDiffEntry,
	mapRelationEntry,
} from "./ContactUpdateBaseRelationDiffRow";
import { addressDiffEntryToIdentifier } from "./contactUpdateUtils";

interface Props {
	row: ContactUpdateAddressDiffRowResource;
}

const Address: FC<ContactUpdateAddressDiffEntryResource> = ({ zip, city, street, houseNumber }) => {
	return (
		<div>
			<div>
				{zip} {city}
			</div>
			<div>
				{street} {houseNumber}
			</div>
		</div>
	);
};

export const ContactUpdateAddressDiffRow: FC<Props> = ({ row }) => {
	const { t } = useTranslation();
	const [field] = useField("addresses");
	const value = field.value[addressDiffEntryToIdentifier(row.currentContact)];
	const identifier = addressDiffEntryToIdentifier(row.currentContact);

	const currentContact: ContactUpdateInquiryDiffEntry = {
		...mapRelationEntry(row.currentContact),
		active: value === "currentContact",
		heading: t("Address"),
		value: <Address {...row.currentContact} />,
		onClick: () =>
			field.onChange({
				target: {
					name: field.name,
					value: { ...field.value, [identifier]: "currentContact" },
				},
			}),
	};

	const updatedContact: ContactUpdateInquiryDiffEntry = {
		...mapRelationEntry(row.updatedContact),
		active: value === "updatedContact",
		heading: t("Address"),
		value: <Address {...row.updatedContact} />,
		onClick: () =>
			field.onChange({
				target: {
					name: field.name,
					value: { ...field.value, [identifier]: "updatedContact" },
				},
			}),
	};

	return <ContactUpdateBaseRelationDiffRow currentContact={currentContact} updatedContact={updatedContact} />;
};
